import logo from '../../../../assets/images/logo_side_cropped.png';
import { profileSidebarLinks } from './ProfileSidebar.data';
import ProfileSidebarItem from './ProfileSidebarItem/ProfileSidebarItem';
import { ReactComponent as LogoutIcon } from '../../../../assets/vectors/logout.svg';
import { Link, useNavigate } from 'react-router-dom';
import { ProfileSidebarProps } from './ProfileSidebar.types';
import { useCurrentUser } from '../../../../hooks/useCurrentUser/useCurrentUser';
import { useMemo, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { signOut } from '../../../../store/authentication/authenticationActions/authenticationActions';
import { getLoginUrlByRole } from '../../../../utils/helpers/router/getLoginUrlByRole';
import { UserRoles } from '../../../../types/models/user/user.types';
import Button from '../../../designSystem/Button/Button';
import { ButtonColor } from '../../../designSystem/Button/Button.types';
import { ReactComponent as MenuIcon } from '../../../../assets/vectors/menu.svg';

export default ({ currentView }: ProfileSidebarProps) => {
  const navigate = useNavigate();

  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const currentUser = useCurrentUser();

  const [isActive, setActive] = useState(false);

  const currentItemsList = useMemo(() => {
    if (currentUser) {
      return profileSidebarLinks[currentUser?.role];
    } else {
      return [];
    }
  }, [currentUser]);

  return (
    <div className={`profile__sidebar${isActive ? ' profile__sidebar--active' : ''}`}>
      <div className="profile__sidebar-main">
        <div className="flex-column">
          <Link to="/dashboard">
            <img className="profile__logo" src={logo} />
          </Link>
          <div className="profile__sidebar-list">
            {currentItemsList?.map(({ icon, label, path }, index) => (
              <ProfileSidebarItem
                key={index}
                to={`/profile/${path}`}
                isActive={path.split('/')[0] === currentView}
                isCompany={currentUser?.role === UserRoles.Entreprise}
                {...{ icon, label }}
              />
            ))}
            <Button
              style={{
                textAlign: 'center',
              }}
              color={
                currentUser?.role === UserRoles.Entreprise
                  ? ButtonColor.Secondary
                  : ButtonColor.Primary
              }
              onClick={() => navigate('/dashboard')}>
              Retour
            </Button>
          </div>
        </div>
        <ProfileSidebarItem
          icon={LogoutIcon}
          label="Se déconnecter"
          isActive={false}
          to={getLoginUrlByRole(currentUser?.role)}
          onClick={() =>
            signOut(queryClient)(dispatch).then(() =>
              navigate(getLoginUrlByRole(currentUser?.role))
            )
          }
        />
      </div>
      <div className={`profile__sidebar-trigger-box`} onClick={() => setActive((state) => !state)}>
        <MenuIcon className="profile__sidebar-trigger" />
      </div>
    </div>
  );
};
